// src/components/common/Navbar.js
import React from 'react';
import { Link } from 'react-router-dom';
// import './Navbar.css'; // 必要であればNavbar専用のCSSを作成

const Navbar = () => {
  return (
    <nav className="main-nav">
      <Link to="/" className="nav-logo">World Tower Residence</Link>
      <div className="nav-links">
        <Link to="/">ホーム</Link>
        <Link to="/facilities/availability">施設予約状況</Link>
        <Link to="/facilities/bar-lounge">バーラウンジ</Link>
        {/* 将来的なリンク */}
        {/* <Link to="/facilities/gym">ジム</Link> */}
        {/* <Link to="/announcements">お知らせ</Link> */}
      </div>
    </nav>
  );
};

export default Navbar;